import { useState, useCallback } from 'react';

export function useSearch() {
  const [searchTerm, setSearchTerm] = useState('');

  const filterBySearch = useCallback(<T extends { guestName: string; guestEmail: string }>(
    items: T[]
  ): T[] => {
    if (!searchTerm.trim()) return items;
    const term = searchTerm.toLowerCase();
    return items.filter(item =>
      item.guestName.toLowerCase().includes(term) ||
      item.guestEmail.toLowerCase().includes(term)
    );
  }, [searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    filterBySearch,
  };
}
